<template>
  <div class="tournament-single">
    <div class="container">
      <TournamentHeader :tournament="tournament"></TournamentHeader>
      <div class="tournament-content">
        <div class="row">
          <div class="col-12 col-md-8">
            <h1>Administração do Campeonato</h1>
          </div>
          <div class="col-12 col-md-4">
            <a class="btn btn-link" href="/suporte#admin-campeonatos">Ajuda</a>
            <br>

            <router-link
              :to="{ name: 'TournamentEdit', params: { id: tournament.slug } }"
              class="btn btn-primary btn-large"
            >Editar campeonato</router-link>
          </div>
        </div>


        <b-tabs content-class="mt-3" fill>
          <b-tab title="Usuários">
            <div class="row justify-content-center">
              <div class="col-12 col-md-8">
                <h4>Usuários Administradores</h4>
                <p class="lead">
                  Os usuários selecionados aqui tem acesso a este painel de gestão do campeonato
                </p>

                <b-list-group>
                  <b-list-group-item v-for="staff in tournament.tournament_staff" :key="staff.id">
                    <router-link :to="{ name: 'UserSingle', params: { id: staff.user.id }}">
                      <div class="user-image">
                        <b-img-lazy
                          rounded="circle"
                          :src="staff.user.avatar.url"
                          :alt="staff.nickname"
                          v-if="staff.user.avatar"
                        />
                      </div>
                      <span>{{ staff.user.nickname }}</span>
                    </router-link>
                    <b-badge @click="deleteStaff(staff.user.id)" variant="danger">remover</b-badge>
                  </b-list-group-item>
                </b-list-group>

                <br>
                <br>

                <b-alert show>
                  informe abaixo a id do usuário que deseja adicionar
                  <br>
                  <small>
                    ex: https://queota.club/users/<strong>76561198272319360</strong> (apenas o final)
                  </small>
                </b-alert>

                <form @submit.stop.prevent="handleCreateStaffSubmit">
                  <b-input-group class="mt-3">
                    <b-form-input placeholder="id do usuário" v-model="user_id"></b-form-input>
                    <b-input-group-append>
                      <b-button type="submit" v-if="user_id.length > 0" variant="success">adicionar</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </form>

              </div>
            </div>
          </b-tab>

          <b-tab title="Times" active>
            <div class="row justify-content-center">
              <div class="col-12 col-md-8">
                <h4>Times</h4>
                <p class="lead">
                  Gerencie os times inscritos no campeonato
                </p>

                <h4>Times inscritos ({{tournament.tournament_teams.length}} de {{tournament.slots}})</h4>
                <div class="team" v-for="team in tournament.tournament_teams" :key="team.slug">
                  <TeamCard :team="team.team"></TeamCard>
                  <b-badge class="badges" variant="success" v-if="team.payed && team.approved">
                    <i class="fas fa-check"></i>
                    confirmado
                  </b-badge>

                  <b-badge
                    class="badges"
                    v-else
                    v-b-tooltip.hover
                    title="esse é um processo manual da equipe do QUEOTA.club, basta aguardar"
                  >
                    <i class="fas fa-clock"></i>
                    aguardando confirmação
                  </b-badge>
                  <b-badge @click="deleteTeam(team.team.to_param)" variant="danger">remover</b-badge>
                  <hr>
                </div>



                <br>
                <br>

                <b-alert show>
                  informe abaixo a id do time para adicionar
                  <br>
                  <small>
                    ex: https://queota.club/teams/<strong>takgota</strong> (apenas o final)
                  </small>
                </b-alert>

                <form @submit.stop.prevent="handleCreateTeamSubmit">
                  <b-input-group class="mt-3">
                    <b-form-input placeholder="id do time" v-model="team_id"></b-form-input>
                    <b-input-group-append>
                      <b-button type="submit" v-if="team_id.length > 0" variant="success">adicionar</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </form>
              </div>
            </div>
          </b-tab>

        </b-tabs>
      </div>
    </div>
  </div>
</template>

<style lang="sass">
.tournament-single
  .page-header
    width: 100%
    height: 650px
  .container
    .tournament-content
      background: #efefef
      border-left: 1px solid #fff
      border-right: 1px solid #fff
      border-bottom: 1px solid #fff
      padding: 20px

.user-image
  display: inline-block
  width: 32px
  height: 32px
  img
    width: 32px
    height: 32px
</style>


<script>
import TeamCard from "@/components/TeamCard";
import TournamentHeader from "@/components/TournamentHeader";
import { DateTime } from "luxon";
export default {
  name: "TournamentAdmin",
  data() {
    return {
      tournament: {
        featured_image: "",
        title: "",
        id: 0,
        cover: {},
        badge: {},
        tournament_teams: [],
        rounds: [],
        matches: []
      },
      team_a_id: 0,
      team_b_id: 0,
      teams: [],
      startTime: {},
      user_id: "",
      team_id: ""
    };
  },
  metaInfo() {
    return {
      title: `${this.tournament.name}`
    };
  },

  computed: {
    isTournamentAdmin: function() {
      return (
        this.$store.getters.isLoggedIn &&
        this.tournament &&
        this.tournament.tournament_staff &&
        this.tournament.tournament_staff
          .map(i => i.user.id)
          .includes(this.$store.getters.user.id)
      );
    }
  },

  methods: {
    initialize() {
      this.$http
        .get("tournaments/" + this.$route.params.id + ".json")
        .then(response => {
          this.tournament = response.data;
          if (!this.isTournamentAdmin)
            this.$router.push("/tournaments/" + this.$route.params.id);
        });
    },

    handleCreateStaffSubmit() {
      this.$http
        .post(`tournaments/${this.$route.params.id}/create_staff.json`, {
          user_id: this.user_id
        })
        .then(response => {
          this.$notify({
            group: "all",
            title: "Usuário adicionado como administrador do campeonato"
          });
          this.user_id = "";
          this.initialize();
        })
        .catch(error => {
          alert("Usuário não encontrado");
          this.user_id = "";
        });
    },

    handleCreateTeamSubmit() {
      this.$http
        .post(`tournaments/${this.$route.params.id}/create_team.json`, {
          team_id: this.team_id
        })
        .then(response => {
          this.$notify({
            group: "all",
            title: "Time adicionado ao campeonato"
          });
          this.team_id = "";
          this.initialize();
        })
        .catch(error => {
          console.log(error.response.status == 404);
            alert("Time não encontrado ou o time não possui 5 jogadores cadastrados (mínimo)");
          // console.log(error.message)
          this.team_id = "";
        });
    },

    deleteTeam(team_id) {
      if (confirm("Você tem certeza? Essa ação não tem retorno!"))
        this.$http
          .get(
            `tournaments/${
              this.$route.params.id
            }/delete_team.json?team_id=${team_id}`
          )
          .then(response => {
            this.$notify({
              group: "all",
              title: "Time removido do campeonato"
            });
            this.initialize();
          })
          .catch(error => {
            alert("Time não encontrado");
          });
    },

    deleteStaff(user_id) {
      if (confirm("Você tem certeza? Essa ação não tem retorno!"))
        this.$http
          .get(
            `tournaments/${
              this.$route.params.id
            }/delete_staff.json?user_id=${user_id}`
          )
          .then(response => {
            this.$notify({
              group: "all",
              title: "Usuário removido como administrador do campeonato"
            });
            this.initialize();
          })
          .catch(error => {
            alert("Usuário não encontrado");
          });
    }
  },
  mounted() {
    this.initialize();
  },
  watch: {
    "$route.params.id": function(id) {
      this.initialize();
    }
  },
  components: {
    TeamCard,
    TournamentHeader
  }
};
</script>
